import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monitoring-dashboard',
  templateUrl: './monitoring-dashboard.component.html',
  styleUrls: ['./monitoring-dashboard.component.css']
})
export class MonitoringDashboardComponent implements OnInit {
  tabs: any = [
    {
      name: 'Errors',
      route: 'errors'
    },
    {
      name: 'Requests Metrics',
      route: 'requests-metrics'
    }
  ];
  activeTab = this.tabs[0].name;

  constructor() { }
  
  ngOnInit() { }

  setActiveTab(tab) {
    this.activeTab = tab.name;
  }
}



// WEBPACK FOOTER //
// ./src/app/monitoring/components/monitoring-dashboard/monitoring-dashboard.component.ts